import { Group, Title } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

export const DeviceManagementHeader = () => {
  const { t } = useTranslation();
  return (
    <Group position="apart" mb={8} align="center">
      <Group spacing={8} align="center">
        <Title order={4} c="gray.9">
          {t('마이페이지_기기관리_타이틀')}
        </Title>
      </Group>
    </Group>
  );
};
